import { useQuery } from '@tanstack/react-query';
import type { ConnectedAssetsProvidersResponse } from '../types';

export default function useConnectedAssetsProviders() {
  return useQuery<ConnectedAssetsProvidersResponse>({
    queryKey: ['connected-assets', 'providers'],
  });
}
